import thailand from '@/assets/db.json'
export default {
    data () {
        return {
            provinceAll: [],
            zipcodeAll: []
        }
    },
    created: function () {
        this.zipcodeAll = this.getAllZipcode()
        this.provinceAll = this.getAllProvince()
    },
    methods: {
        getAllProvince () {
            let province = []
            thailand.forEach(e => {
                province.push(e.province)
            })
            province = [...new Set(province)]
            province = province.sort()
            return province
        },
        getAllZipcode () {
            let zipcode = thailand.map(e => {
                if (e.zipcode) {
                    return String(e.zipcode)
                }
            })
            zipcode = [...new Set(zipcode)]
            return zipcode
        },
        findAddress (queryString = '') {
            let getQueryAddress = queryString => {
                return thailand.filter(item => {
                    return (
                        new RegExp(queryString.trim()).test(item.zipcode) ||
                        new RegExp(queryString.trim()).test(item.province) ||
                        new RegExp(queryString.trim()).test(item.district) ||
                        new RegExp(queryString.trim()).test(item.amphoe)
                    )
                })
            }
            // console.log(getQueryAddress)
            let splittedText = queryString.split(' ')
            let querryResultArray = []
            splittedText.forEach(queryString => {
                querryResultArray.push(getQueryAddress(queryString))
            })
            let result = null
            if (querryResultArray.length === 1) {
                result = querryResultArray[0]
            } else {
                let base = querryResultArray[0]
                for (let i = 1; i < querryResultArray.length; ++i) {
                    base = base.filter((item) => {
                        return querryResultArray[i].indexOf(item) !== -1
                    })
                }
                result = base
            }
            return result
        },
        findZipcode (zipcode) {
            let resultFilter = thailand.filter(item => parseInt(item.zipcode) === parseInt(zipcode))
            return resultFilter
        }
    }
}
